'use client';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormikContext } from 'formik';
import Typography from '@mui/material/Typography';
import { buildImageUrl } from '../../utils/images';
import type { Image } from '../../types/Image';
import type { GroupFormValues } from './form';
import ImageDropzone from '../events/image-dropzone';

type Props = {
  disabled: boolean;
  currentImage?: Image;
};

const GroupFormImage = ({ disabled, currentImage }: Props) => {
  const {
    values: { image },
    setFieldValue,
  } = useFormikContext<GroupFormValues>();

  const [showCurrentImage, setShowCurrentImage] = useState(true);

  const filePreviewUrl = useMemo(
    () => (image instanceof File ? URL.createObjectURL(image) : null),
    [image],
  );

  useEffect(() => {
    return () => {
      if (filePreviewUrl) {
        URL.revokeObjectURL(filePreviewUrl);
      }
    };
  }, [filePreviewUrl]);

  const previewUrl =
    filePreviewUrl ??
    (currentImage && showCurrentImage
      ? buildImageUrl(currentImage, '400x400iwe')
      : null);

  const handleFileAccepted = useCallback(
    (file: File) => {
      setFieldValue('image', file);
    },
    [setFieldValue],
  );

  const handleRemove = useCallback(() => {
    setFieldValue('image', null);
    setShowCurrentImage(false);
  }, [setFieldValue]);

  return (
    <>
      <Typography variant="h2">Image</Typography>
      <ImageDropzone
        previewUrl={previewUrl}
        onFileAccepted={handleFileAccepted}
        onRemove={handleRemove}
        disabled={disabled}
      />
    </>
  );
};

export default GroupFormImage;
